<template>
  <label class="radio">
    <input
      type="radio"
      :name="rProps.name"
      :value="rProps.value"
      :checked="rProps.checked"
      :disabled="rProps.disabled"
      @change="rProps.handleOnChange"
    />
    <div class="radio__content-wrapper">
      <slot></slot>
    </div>
  </label>
</template>

<script>
export default {
  name: 'TRadio',
  inject: [
    'radioGroupContext',
  ],
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rProps() {
      const rProps = {};
      rProps.value = this.value;

      if (this.radioGroupContext) {
        const {
          name,
          value,
          disabled,
        } = this.radioGroupContext;

        rProps.name = name;
        rProps.handleOnChange = this.onChange;
        rProps.checked = this.value === value;
        rProps.disabled = this.disabled || disabled;
      } else {
        rProps.name = this.name;
        rProps.handleOnChange = this.handleOnChange;
        rProps.checked = this.checked;
        rProps.disabled = this.disabled;
      }

      return rProps;
    },
  },
  methods: {
    onChange() {
      this.$emit('change', this.value);
      if (this.radioGroupContext && this.radioGroupContext.onChange) {
        this.radioGroupContext.onChange(this.value);
      }
    },
    handleOnChange() {
      this.$emit('change', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio {
  display: flex;
  flex-direction: row;
  align-items: center;

  &__content-wrapper {
    display: inline-flex;
    padding-inline: 8px;
  }
}
</style>
